import React, { useCallback, useState } from 'react'
import { Alert } from 'components'
import { alerts as alertKeys, grades } from 'keys'
import { AutoComplete, Input } from 'components/Form'
import { useAlert } from 'components/Alerts/hooks'
import { useSelector } from 'react-redux'
import { createClassHooks } from '../CreateClass'
import { useQueryClient } from '@tanstack/react-query'
import { SmallSpace } from 'styles/GlobalStyle'
import { semesterAndYearOptions } from 'keys/years'
import { getCurrentSchoolYear } from 'utils/general'
import qc from 'keys/queryClient'

const AddLearningGroup = (props) => {
    const { setAlerts } = useAlert()
    const { alerts } = useSelector(state => state.general)
    const { grades, schoolClasses } = useSelector(state => state.testTaker)

    const currentSchoolYear = getCurrentSchoolYear()

    const addLearningGroupAlert = alerts[alertKeys.addLearningGroup]

    const [groupName, setGroupName] = useState(addLearningGroupAlert?.props?.name)
    const [schoolYear, setSchoolYear] = useState(currentSchoolYear)

    const queryClient = useQueryClient()

    const createLearningGroup = createClassHooks.useCreateLearningGroup()
    const updateLearningGroup = createClassHooks.useUpdateLearningGroup()

    const handleAlert = useCallback((val) => {
        setAlerts(alertKeys.addLearningGroup, val)
    }, [])

    const { affiliation, id: learningUnitId } = addLearningGroupAlert?.props || {}

    const editLearningGroup = useCallback(async () => {
        handleAlert(false)
        // במקרה שמועבר אוביקט המכיל מזהה אנחנו יודעים שמדובר בפעולת עדכון
        if (learningUnitId)
            await updateLearningGroup({
                name: groupName,
                id: learningUnitId
            })
        else
            await createLearningGroup({
                name: groupName,
                affiliation: affiliation,
                school_year: schoolYear?.id || schoolYear
            })

        queryClient.invalidateQueries({ queryKey: [qc.learningGroups, affiliation?.toString()] })
    }, [groupName, schoolYear, addLearningGroupAlert])

    const footerActions = React.useMemo(
        () => [
            { label: "שמירה", variant: "regular", color: "thirdly", action: editLearningGroup },
            { label: "ביטול", variant: "white", color: "thirdly4", action: () => handleAlert(false) }
        ], [groupName, schoolYear, addLearningGroupAlert]
    )

    return (
        <Alert
            systemUI
            title={"הוספת קבוצת למידה"}
            footerActions={footerActions}
            handleAlert={handleAlert}
        >
            <SmallSpace />
            <Input
                placeholder="שם הקבוצה"
                input={{
                    value: groupName,
                    onChange: setGroupName
                }}
            />
            <SmallSpace />
            {learningUnitId ? null :
                <React.Fragment>
                    <AutoComplete
                        name="role"
                        options={semesterAndYearOptions}
                        placeholder="שנת לימודים"
                        input={{
                            value: schoolYear,
                            onChange: setSchoolYear
                        }}
                        labelKey="label"
                    />
                    <SmallSpace />
                    <div>{"אי בחירת שנת לימודים יוצר את הקבוצה ללא שנה מסויימת"}</div>
                </React.Fragment>}
        </Alert>
    )
}

export default AddLearningGroup